export function on(event, cb){
	const subscribers = Object.assign({}, this.subscribers);
	if(!subscribers[event]){
		subscribers[event] = [];
	}
	subscribers[event].push(cb);
	this.subscribers = subscribers;

	return this;
}

export function emit(event, ...payload){
	if(this.subscribers[event]){
		this.subscribers[event].map(cb => cb.apply(this, payload));
	}
}



// WEBPACK FOOTER //
// ./node_modules/ui-slider/app/js/src/slider/event-hooks.js